import { ReactNode } from 'react';
import styled from 'styled-components';
import { media } from '../../../../helpers/breakpoints';
import { ArrowBackIc, CameraOutlineIc } from '@dsch/dd-icons';
interface GalleryHeaderProps {
  className?: string;
  currentCountPosition: number;
  totalMedia: number;
  askToClose: () => void;
  renderShareAd?: ReactNode;
  renderSaveAd?: ReactNode;
  renderShareMedia?: ReactNode;
  renderCounter?: (index: number, total: number) => ReactNode;
}

const Header = styled.header`
  padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M16}`};
  // TODO: Chat to design about rgba values of our colours
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
`;

const Back = styled.button`
  background: transparent;
  border: 0;
  margin: 0;
  padding: ${({ theme }) => theme.spacing.S8};
  width: 40px;
  height: 40px;
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Count = styled.div`
  ${({ theme }) => theme.fontSize.L18};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  justify-content: center;
  flex: 2;

  .camera-icon {
    display: none;
    color: ${({ theme }) => theme.colors.GREY_DARKER};
    margin-right: ${({ theme }) => theme.spacing.S8};

    ${media.large} {
      display: inline-block;
    }
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;

  ${media.medium} {
    gap: ${({ theme }) => theme.spacing.S4};
  }
`;

function GalleryHeader({
  className,
  currentCountPosition,
  totalMedia,
  askToClose,
  renderShareMedia,
  renderShareAd,
  renderSaveAd,
  renderCounter,
}: GalleryHeaderProps) {
  return (
    <Header className={className}>
      <BackWrapper>
        <Back
          data-testid="gallery-close"
          onClick={askToClose}
          aria-label="Close gallery"
          type="button"
        >
          <ArrowBackIc width="24" height="24" />
        </Back>
      </BackWrapper>
      <Count>
        <CameraOutlineIc className="camera-icon" />
        {renderCounter
          ? renderCounter(currentCountPosition, totalMedia)
          : `${currentCountPosition}/${totalMedia}`}
      </Count>
      <Actions>
        {renderShareMedia}
        {renderShareAd}
        {renderSaveAd}
      </Actions>
    </Header>
  );
}

export { GalleryHeader };
